import SyntheseListController from './synthese.list.controller';

export default {
    controller: SyntheseListController,
    template: require('./synthese.list.tpl.html')
};
